/** Identity seam for D&D Queue — mirrors rukh-pd-queue/src/services/identity.ts */

export interface DdOperator {
  id: string
  name: string
  email: string
  role: string
  team: string
}

const DEFAULT_OPERATOR: DdOperator = {
  id: 'u-taylor-whitney',
  name: 'Taylor Whitney',
  email: 'taylor.whitney@fastsigns.com',
  role: 'Director, AI & Automation Strategy',
  team: 'Visual Solutions Group',
}

let currentOperator: DdOperator = { ...DEFAULT_OPERATOR }

export function setDdQueueOperator(operator: DdOperator): void {
  currentOperator = operator
}

export function resetDdQueueOperator(): void {
  currentOperator = { ...DEFAULT_OPERATOR }
}

export function ddQueueCurrentOperator(): DdOperator {
  return currentOperator
}
